import { m } from 'framer-motion';
import { Navigate } from 'react-router-dom';

import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';

import { paths } from 'src/routes/paths';
import { RouterLink } from 'src/routes/components';

import { ForbiddenIllustration } from 'src/assets/illustrations';

import { varBounce, MotionContainer } from 'src/components/animate';

import { useAuthContext } from 'src/auth/hooks';

// ----------------------------------------------------------------------

export function FeatureFlagGuard({ children, feature, redirect = true, sx = {} }) {
  const { user } = useAuthContext();

  const isEnabled = user?.features?.[feature] ?? false;

  if (!isEnabled) {
    if (redirect) {
      return <Navigate to={paths.root} replace />;
    }

    return (
      <Container component={MotionContainer} sx={{ textAlign: 'center', py: { xs: 5, sm: 10 }, ...sx }}>
        <m.div variants={varBounce().in}>
          <Typography variant="h3" sx={{ mb: 2 }}>
            Feature not available
          </Typography>
        </m.div>

        <m.div variants={varBounce().in}>
          <Typography sx={{ color: 'text.secondary' }}>
            This feature is not enabled for your organization.
          </Typography>
        </m.div>

        <m.div variants={varBounce().in}>
          <ForbiddenIllustration sx={{ my: { xs: 5, sm: 8 } }} />
        </m.div>

        <Button component={RouterLink} href="/" size="large" variant="contained" color="inherit">
          Go to home
        </Button>
      </Container>
    );
  }

  return <>{children}</>;
}
